import React from "react";
import ReactDOM from "react-dom";
import Main from "./Main";
import Favicon from "react-favicon";
import "./services/i18n";
import "semantic-ui-css/semantic.min.css";
import "./css/index.css";
import "./css/mobile_index.css";
import logo from "./assets/images/MEMC-logo.png";
import { Helmet } from "react-helmet";

ReactDOM.render(
  <div>
    <Favicon url={logo} />
    <React.StrictMode>
      <Helmet>
        <title>MyEmbassyMyConsulate</title>
      </Helmet>
      <React.Suspense fallback="">
        <Main />
      </React.Suspense>
    </React.StrictMode>
  </div>,
  document.getElementById("root")
);
